import gql from "graphql-tag";

const CURRENT_USER = gql`
  query GetCurrentUser {
    user: me {
      _id
      id
      email
      firstName
      lastName
      displayName
      profileImage
      role
      isVerified
      isActive
      lastLogin
      createdAt
      updatedAt
      isArtist
      isAdmin
      emailVerified
    }
  }
`;

export interface CurrentUser {
  id: string;
  email: string;
  role: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  profileImage?: string;
  isVerified: boolean;
  isActive: boolean;
  lastLogin?: string | number | null;
  createdAt: string | number;
  updatedAt: string | number;
  /** Same as id; legacy clients expect Mongo-style _id. */
  _id: string;
  isArtist: boolean;
  isBeneficiary?: boolean;
  isAdmin: boolean;
  emailVerified: boolean;
  /** Optional; not selected on me — legacy screens may still read it from other queries. */
  balanceInPennies?: number;
}

export interface CurrentUserQueryResponse {
  me: CurrentUser;
  getCurrentUser: CurrentUser; // alias for compatibility
  user: CurrentUser; // alias for compatibility
}

export default CURRENT_USER;
